
export default {
  data() {
    return {
      title: "Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "claims",
          name: "claims",
          content: "step-by-step look at how to file a claim",
        },
      ],
    };
  },
};
